// src/services/api.js
import axios from 'axios';
import { toast } from 'react-toastify';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  timeout: 5000,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      switch (status) {
        case 401:
          toast.error('Session expired. Please log in again.');
          window.location.href = '/login';
          break;
        case 403:
          toast.error('You do not have permission to access this resource.');
          window.location.href = `/error?message=${encodeURIComponent(
            data.message
          )}&statusCode=403`;
          break;
        default:
          toast.error(data.message || 'An unexpected error occurred.');
          break;
      }
    } else if (error.request) {
      toast.error('No response from server. Please try again later.');
    } else {
      toast.error('An unexpected error occurred. Please try again.');
    }
    return Promise.reject(error);
  }
);

export default api;
// // src/utils/api.js
// import axios from 'axios';

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
//   timeout: 5000,
// });

// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response) {
//       // The request was made and the server responded with a status code
//       // that falls out of the range of 2xx
//       if (error.response.status === 401) {
//         // Unauthorized - redirect to login
//         window.location.href = '/login';
//       } else if (error.response.status === 403) {
//         // Forbidden - redirect to error page
//         window.location.href = `/error?message=${encodeURIComponent(
//           error.response.data.message
//         )}&statusCode=403`;
//       } else {
//         // Other error statuses
//         window.location.href = `/error?message=${encodeURIComponent(
//           error.response.data.message
//         )}&statusCode=${error.response.status}`;
//       }
//     } else if (error.request) {
//       // The request was made but no response was received
//       window.location.href = `/error?message=${encodeURIComponent(
//         'No response from server'
//       )}&statusCode=500`;
//     } else {
//       // Something happened in setting up the request that triggered an Error
//       window.location.href = `/error?message=${encodeURIComponent(
//         'Error setting up request'
//       )}&statusCode=500`;
//     }
//     return Promise.reject(error);
//   }
// );

// export default api;

// import axios from 'axios';

// const api = axios.create({
//   baseURL: 'http://localhost:5000/api', // Update with your backend URL
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // api.interceptors.request.use((config) => {
// //   const token = localStorage.getItem('token');
// //   if (token) {
// //     config.headers.Authorization = `Bearer ${token}`;
// //   }
// //   return config;
// // });

// // // For customer dashboard
// // axios.get('/api/customers/subscriptions', {
// //     headers: { Authorization: `Bearer ${localStorage.getItem('customerToken')}` }
// // });

// // // For owner dashboard
// // axios.get('/api/restaurants', {
// //     headers: { Authorization: `Bearer ${localStorage.getItem('ownerToken')}` }
// // });

// export default api;

// // // Add to authService.js

// // export const verifyToken = async (token) => {
// //     try {
// //         const response = await axios.get('/api/auth/verify-token', {
// //             headers: { Authorization: `Bearer ${token}` }
// //         });
// //         return response.data;
// //     } catch (error) {
// //         return { valid: false };
// //     }
// // };

// // // Example usage in a component

// // useEffect(() => {
// //     const checkAuth = async () => {
// //         const token = localStorage.getItem('customerToken');
// //         if (token) {
// //             const verificationResult = await verifyToken(token);
// //             if (verificationResult.valid) {
// //                 // Proceed to subscribe or access protected resources
// //                 subscribeToRestaurant(restaurantId, token);
// //             } else {
// //                 // Handle invalid token (redirect to login, clear storage, etc.)
// //                 localStorage.removeItem('customerToken');
// //                 history.push('/customer-login');
// //             }
// //         }
// //     };

// //     checkAuth();
// // }, []);

// // // src/components/ProtectedRoute.js
// // import React from 'react';
// // import { Route, Redirect } from 'react-router-dom';

// // const ProtectedRoute = ({ component: Component, role, ...rest }) => {
// //     let token;
// //     if (role === 'customer') {
// //         token = localStorage.getItem('customerToken');
// //     } else if (role === 'owner') {
// //         token = localStorage.getItem('ownerToken');
// //     }

// //     const isAuthenticated = token ? true : false;

// //     return (
// //         <Route {...rest} render={props => (
// //             isAuthenticated ? (
// //                 <Component {...props} />
// //             ) : (
// //                 <Redirect to={`/${role}-login`} />
// //             )
// //         )} />
// //     );
// // };

// // export default ProtectedRoute;
